import t from 'assets/intl/fr'

const translate = (id) => {
  return t[id] || id
}
export default translate
